import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ComponentType } from 'react';
import type { AggregatedMetric } from './api.js';

export const TREND_ICON: Record<AggregatedMetric['direction'], ComponentType<SvgIconProps>> = {
  up: TrendingUpIcon,
  down: TrendingDownIcon,
  flat: TrendingFlatIcon,
};

export type MetricAccent = 'primary' | 'success' | 'warning' | 'error' | 'secondary';

export const CREATIVE_SCORE_COMPONENT_ACCENT = {
  hook: 'secondary',
  engagement: 'primary',
  watch: 'error',
  leadingKpi: 'warning',
  elements: 'success',
} as const satisfies Record<string, MetricAccent>;
